import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import NavLink from '../navLink'
import { BASE_URL } from '../../api/api'

const Hyjj = ({ meetNewsList = {} }) => {
  const { channel = [], list1 = [], list2 = [] } = meetNewsList
  const [channel1, channel2] = channel
  const { name, id } = channel1 || {}
  const { name: name1, id: id2 } = channel2 || {}

  return (
    <div className="mt-[60px] flex justify-between flex-wrap lg:flex-nowrap px-5 lg:px-0">
      <div className="">
        <div className="flex items-center justify-center lg:justify-start">
          <H2Title className="lg:border-l-[5px] pl-2" title={name} />
          <GenDuo href={`/hyjj/channel_id/${id}`} className="hidden lg:block ml-auto" />
        </div>
        {list1.map(({ id, title, description, image = '', outlink = '' }, key) => (
          <div
            key={key}
            className={`flex items-center ${key && 'border-t border-[#E7E7E7]'} py-[22px]`}
          >
            <img className="w-[160px] h-[116px]" src={`${BASE_URL}${image || ''}`} alt="" />
            <div className="ml-[26px] max-h-[116px]">
              <NavLink
                isOutLink={!!outlink}
                className="text-[#333] font-alhpr"
                to={outlink || `/wzxq/id/${id}`}
              >
                {title}
              </NavLink>
              <p className="mt-[16px] text-sm text-[#555] font-sourceHan leading-[28px] line-clamp-2 w-[160px] lg:w-[387px]">
                {description}
              </p>
            </div>
          </div>
        ))}
        <div className="flex lg:hidden justify-center mt-8 flex-col">
          <hr className="h-[1px] bg-[#E7E7E7] w-full" />
          <GenDuo
            href={`/hyjj/channel_id/${id}`}
            className="mx-auto mt-[30px] bg-[#0189D5] px-6 py-2 rounded-xl text-white"
          />
        </div>
      </div>
      <div className="lg:ml-10 mt-10 lg:mt-0">
        <div className="flex items-center justify-center lg:justify-start">
          <H2Title className="lg:border-l-[5px] pl-2" title={name1} />
          <GenDuo href={`/hyjj/channel_id/${id2}`} className="hidden lg:block ml-auto" />
        </div>
        {list2.map(({ id, title, description, image = '', outlink = '' }, key) => (
          <div
            key={key}
            className={`flex items-center ${key && 'border-t border-[#E7E7E7]'} py-[22px]`}
          >
            <img className="w-[160px] h-[116px]" src={`${BASE_URL}${image || ''}`} alt="" />
            <div className="ml-[26px] max-h-[116px]">
              <NavLink
                isOutLink={!!outlink}
                className="text-[#333] font-alhpr"
                to={outlink || `/wzxq/id/${id}`}
              >
                {title}
              </NavLink>
              <p className="mt-[16px] text-sm text-[#555] font-sourceHan leading-[28px] line-clamp-2 w-[160px] lg:w-[387px]">
                {description}
              </p>
            </div>
          </div>
        ))}
        <div className="flex lg:hidden justify-center mt-8 flex-col">
          <hr className="h-[1px] bg-[#E7E7E7] w-full" />
          <GenDuo
            href={`/hyjj/channel_id/${id2}`}
            className="mx-auto mt-[30px] bg-[#0189D5] px-6 py-2 rounded-xl text-white"
          />
        </div>
      </div>
    </div>
  )
}

export default Hyjj
